import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import buildActualPath from 'helpers/build-actual-path';
import { Translate } from 'react-redux-i18n';
import { CRITERIA_CONFIG } from 'view/FilterManagement/FilterCriteria';

const FilterResult = ({
    context,
    type,
    payload,
    onClick,
    disabled,
    className,
}) => {
    const handleClick = e => {
        if (disabled) {
            e.preventDefault();
            return;
        }
        else {
            onClick();
        }
    };
    const style = classNames({
        [className]: true,
        'filter-result': true,
        'disabled': disabled,
    });
    return (
        <>
            {
                (type !== null && type !== undefined) ? (
                    <NavLink
                        className={ style }
                        onClick={ handleClick }
                        to={ {
                            pathname: buildActualPath(CRITERIA_CONFIG[type].route),
                            state: { queryPayload: payload },
                        } }
                    >
                        { context?.length ?  context : (<Translate value="filters.link" />) }
                    </NavLink>
                ) : null
            }
        </>

    );
};

FilterResult.propTypes = {
    context: PropTypes.string,
    type: PropTypes.number,
    payload: PropTypes.shape({}),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
};
FilterResult.defaultProps = {
    context: undefined,
    type: undefined,
    payload: undefined,
    onClick: () => {},
    disabled: false,
    className: undefined,
};

export default FilterResult;
